import React from "react";
import { Link } from "react-router-dom";
import { Arrow, CalendarIcon, PinIcon } from "./Icons";
import { STORAGE_URL } from "../config";
import { formatEventDate } from "../utils/TextUtils";

// One upcoming event, as shown on the home page and on the Events page:
// the picture, the date and venue, the name and the start of the description.
function EventCard({ event, className = "", style }) {
    const link = `/events/${event.id}/${event.slug}`;
    const when = formatEventDate(event.start_date);

    return (
        <article className={`cf-event ${className}`} style={style}>
            <Link className="cf-event-photo" to={link} tabIndex={-1} aria-hidden="true">
                {event.image
                    ? <img src={`${STORAGE_URL}/events/${event.image}`} alt="" loading="lazy" />
                    : <span className="cf-event-nophoto"><CalendarIcon size={34} /></span>}
            </Link>
            <div className="cf-event-body">
                {(when || event.venue) && (
                    <p className="cf-event-meta">
                        {when && <span><CalendarIcon size={14} /> {when}</span>}
                        {event.venue && <span><PinIcon size={14} /> {event.venue}</span>}
                    </p>
                )}
                <h3><Link to={link}>{event.name}</Link></h3>
                {event.description && (
                    <p>
                        {event.description.slice(0, 152)}
                        {event.description.length > 152 ? "..." : ""}
                    </p>
                )}
                <Link className="cf-more" to={link}>See more details <Arrow /></Link>
            </div>
        </article>
    );
}

export default EventCard;
